import { defineStore } from 'pinia'

type Nullable<T> = T | null;

export const useUserStore = defineStore('user', {
    state: () => ({
        //store reactive data properties
        user: {} as Nullable<Server.IUserAccount>
    }),
    getters: {},
    actions: {},
    persist: true
});
